import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from "react-redux"
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {store} from "./store"
import { HelmetProvider } from 'react-helmet-async';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
      <BrowserRouter>
       <Routes>
        <Route path='/*' element={<App/>}/>
       </Routes>
      </BrowserRouter>
      </HelmetProvider>
    </Provider>
  
  </React.StrictMode>
);
